import { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form as BSForm,
  CloseButton,
  Image,
  Badge,
} from "react-bootstrap";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import axios from "axios";
import API from "../../api/api";

function BannersModel({
  show,
  handleClose,
  payload,
  setPayload,
  getAllData,
  hostname,
}) {
  // console.log(payload);

  const [status, setStatus] = useState("inactive");
  const [order, setOrder] = useState(1);

  useEffect(() => {
    if (payload && payload._id) {
      setStatus(payload.status ? "active" : "inactive");
      setOrder(payload.order ?? 1);
    }
  }, [payload._id]);

  const updateBanner = (values = {}) => {
    API
      .post(`/api/banners50/update-banner50`, {
        banner_id: payload?._id,
        status: values.status === "active" ? true : false,
        order: values.order,
      })
      .then((res) => {
        // console.log(res.data);
        getAllData();
        handleClose();
        toast.warning("Banner Updated.", { theme: "colored" });
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        getAllData();
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  const uploadBannerAPI = async (file) => {
    try {
      console.log(file);

      const formData = new FormData();
      formData.append("file", file);

      const res = await API.post(
        `/api/banners50/create-banner50`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("banner uploaded");
      handleClose();
      getAllData();
    } catch (e) {
      console.log(e);
    }
  };

  const deleteBanner = () => {
    API
      .post(`/api/banners50/delete-banner50`, {
        banner_id: payload?._id,
      })
      .then((res) => {
        // console.log(res.data);
        getAllData();
        handleClose();
        toast.warning("Banner deleted.", { theme: "colored" });
        setPayload({});
      })
      .catch((err) => {
        console.log(err);
        getAllData();
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>{payload.loadType}</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {payload.loadType === "Upload Banner" && (
          <Formik
            initialValues={{ banner: null }}
            validationSchema={Yup.object().shape({
              banner: Yup.mixed()
                .required("Banner image is required")
                .test(
                  "fileSize",
                  "File size must be less than 2MB",
                  (value) => {
                    return value && value.size <= 2 * 1024 * 1024; // 2MB
                  }
                )
                .test("fileType", "Only JPG, PNG allowed", (value) => {
                  return (
                    value &&
                    [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/webp",
                    ].includes(value.type)
                  );
                }),
            })}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              await uploadBannerAPI(values.banner);
              resetForm();
              setSubmitting(false);
            }}
          >
            {({ setFieldValue, values, isSubmitting }) => (
              <Form className="p-3">
                {/* File Input */}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(event) => {
                    setFieldValue("banner", event.currentTarget.files[0]);
                  }}
                  className="form-control mb-2"
                />
                <ErrorMessage
                  name="banner"
                  component="div"
                  className="text-danger mb-2"
                />

                {/* Preview */}
                {values.banner && (
                  <div className="mb-3">
                    <img
                      src={URL.createObjectURL(values.banner)}
                      alt="Preview"
                      className="img-fluid mb-2"
                      style={{ maxHeight: "150px", objectFit: "contain" }}
                    />
                    <br />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => setFieldValue("banner", null)}
                    >
                      Remove
                    </button>
                  </div>
                )}
                <br />
                {/* Submit Button */}
                <button
                  type="submit"
                  className="btn btn-primary float-end btn-sm"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Uploading..." : "Upload"}
                </button>
              </Form>
            )}
          </Formik>
        )}
        {payload.loadType === "View Banner" && (
          <div>
            <Image src={payload.imageUrl} fluid />
          </div>
        )}
        {payload.loadType === "Update Banner" && (
          <div>
            <BSForm.Group className="mb-3">
              <BSForm.Label>Status</BSForm.Label>
              <BSForm.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </BSForm.Select>
            </BSForm.Group>

            <BSForm.Group className="mb-3">
              <BSForm.Label>Order</BSForm.Label>
              <BSForm.Control
                type="number"
                value={order}
                onChange={(e) => setOrder(Number(e.target.value))}
                min={1}
              />
            </BSForm.Group>

            <div className="text-end">
              <Button
                variant="warning"
                className="me-3"
                size="md"
                onClick={() => updateBanner({ status, order })}
                style={{ width: 80 }}
              >
                Yes
              </Button>
              <Button
                variant="secondary"
                size="md"
                onClick={handleClose}
                style={{ width: 80 }}
              >
                No
              </Button>
            </div>
          </div>
        )}

        {payload.loadType === "Delete Banner" && (
          <div>
            <>
              <p className="text-danger">
                Are you sure you want to delete this budget ?
                {/* <span className="text-primary">"{payload.amenity_name}"</span>? */}
              </p>
              <div className="text-end">
                <Button
                  variant="danger"
                  className="me-3 "
                  size="md"
                  onClick={deleteBanner}
                  style={{ width: 80 }}
                >
                  Yes
                </Button>
                <Button
                  variant="secondary"
                  size="md"
                  onClick={handleClose}
                  style={{ width: 80 }}
                >
                  No
                </Button>
              </div>
            </>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default BannersModel;
